<script lang="ts" setup>
// @ts-expect-error JS library
import { useMq } from 'vue3-mq'
import { Iconify } from '~/types/assets'

const props = defineProps<{
  endpoint: string
  preview?: boolean
  name?: string
  target?: string
  zoom?: number
  toolbar?: boolean
  scrolling?: boolean
}>()

const { xs, sm, md } = useMq()

const LOADING_TIME = 2500

const loading = ref(true)
const hover = ref(false)

onMounted(() => {
  setTimeout(() => (loading.value = false), LOADING_TIME)
})
</script>

<template lang="pug">
.pdf-viewer__outer(
  @mouseover="hover = true"
  @mouseleave="hover = false"
)
  .pdf-viewer__inner(:class="preview && hover && !loading ? 'filter blur-md' : ''")
    iframe(
      ref="iframe"
      :src="`${endpoint}#toolbar=${toolbar ? '1' : '0'}&zoom=${zoom || (xs || sm ||md ? 0 : 75)}&view=FitH`",
      frameBorder="0",
      seamless="seamless",
      autoplay="1",
      loading="lazy",
      :scrolling="scrolling ? 'yes' : 'no'",
      webkitallowfullscreen,
      mozallowfullscreen,
      allowfullscreen
    )
    Transition(name="fade-top")
      .pdf-viewer__loader(
        v-if="loading"
      )
        IconLogo(
          :size="125"
          :line-drawing="true"
          :landing="true"
          :landing-duration="LOADING_TIME"
        )
  Transition(name="fade")
    .pdf-viewer__inspect(v-if="preview && hover && !loading")
      .pdf-viewer__inspect__content
        Icon(:name="Iconify?.cert")
        p {{ name }}
        NuxtLink(
          :to="target"
          :title="$t('components.pdf.anchor.title', { name })"
          :aria-label="$t('components.pdf.anchor.aria-label', { name })"
        ) {{ $t('misc.inspect') }}
</template>

<style lang="sass" scoped>
*
  @apply transition-all
.pdf-viewer__outer
  @apply w-full h-full relative overflow-hidden
  .pdf-viewer__inner
    @apply w-full h-full overflow-hidden
    iframe
      @apply w-full h-full scrollbar-primary overflow-hidden
    .pdf-viewer__loader
      @apply min-w-full absolute top-0 left-0 right-0 bottom-0 bg-dark-900 animate-[grow_4s_ease-in-out_1] flex-center
      animation-fill-mode: forwards
  .pdf-viewer__inspect
    @apply absolute top-0 left-0 right-0 bottom-0 opacity-0 flex-center
    .pdf-viewer__inspect__content
      @apply bg-light-100 p-4 rounded shadow-2xl flex-center flex-col
      span.iconify
        @apply bg-primary text-4xl
      p
        @apply text-dark-900 text-lg font-bold
      a
        @apply text-primary underline text-base
  &:hover .pdf-viewer__inspect
    @apply opacity-100
</style>
